import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
} from '@lexical/list';
import { ToolbarButton } from '../ToolbarButton';
import { INSERT_TABLE_COMMAND } from '@lexical/table';
import { GridNine, ListBullets, ListNumbers } from '@phosphor-icons/react';
import { useRightSidePanelState } from 'src/hooks';
import { DrawerTooltipContainerRef } from 'src/v2/commonComponents/DrawerTooltipContainer';

import React from 'react';
import { isBetaEnv } from 'src/utils';

interface AdditionalToolbarButtonsProps {
  drawerRef?: React.RefObject<DrawerTooltipContainerRef>;
}

export const AdditionalToolbarButtons = ({
  drawerRef,
}: AdditionalToolbarButtonsProps) => {
  const { isRightPanelFullWidth } = useRightSidePanelState();

  return (
    <>
      <ToolbarButton
        command={INSERT_UNORDERED_LIST_COMMAND}
        payload={undefined}
        Icon={ListBullets}
        title={!isRightPanelFullWidth ? 'Bullet List' : undefined}
        fullWidth={!isRightPanelFullWidth}
        onClick={drawerRef?.current?.onVisibilityToggle}
      />

      <ToolbarButton
        command={INSERT_ORDERED_LIST_COMMAND}
        payload={undefined}
        Icon={ListNumbers}
        title={!isRightPanelFullWidth ? 'Numbered List' : undefined}
        fullWidth={!isRightPanelFullWidth}
        onClick={drawerRef?.current?.onVisibilityToggle}
      />

      {isBetaEnv && (
        <ToolbarButton
          command={INSERT_TABLE_COMMAND}
          payload={{
            columns: String(3),
            includeHeaders: false,
            rows: String(3),
          }}
          Icon={GridNine}
          title={!isRightPanelFullWidth ? 'Table' : undefined}
          fullWidth={!isRightPanelFullWidth}
          onClick={drawerRef?.current?.onVisibilityToggle}
        />
      )}
    </>
  );
};
